export const GLOBAL_STATE = 'Department'

export const DEPARTMENT = 'DEPARTMENT' as const
export const DEPARTMENT_CREATE = 'DEPARTMENT_CREATE' as const
export const DEPARTMENT_DELETE = 'DEPARTMENT_DELETE' as const
export const DEPARTMENT_LIST = 'DEPARTMENT_LIST' as const
export const DEPARTMENT_ALL = 'DEPARTMENT_ALL' as const
export const DEPARTMENT_LABELS = 'DEPARTMENT_LABELS' as const
